import { ClientAPI } from "./client";
import { UserAPI } from "./user/userapi"
import { ServerStatsAPI } from "./misc/serverstats/serverstats"

export class API {
   
    client(clientId: number) {
        return new ClientAPI(clientId)
    }
    user() {
        return new UserAPI()
    }
    readonly serverStats = ServerStatsAPI;
}
